import type { EventSourceMessage } from '@microsoft/fetch-event-source';
import { downloadUrlReceived } from 'src/infra/stores/reducer/sseSlice';
import type { AppDispatch } from 'src/infra/stores/store';

// Track last processed URL and timestamp to prevent duplicate processing
let lastProcessedUrl: string | null = null;
let lastProcessedTime: number = 0;
const DEBOUNCE_MS = 1000; // Ignore duplicate URLs within 1 second

/**
 * Handle SSE download URL events
 * Processes the download URL sent by the server when an async report generation is complete
 * Includes deduplication logic to handle backend sending duplicate events
 */
export const handleDownloadUrlEvent = (event: EventSourceMessage, dispatch: AppDispatch): void => {
  try {
    const data = JSON.parse(event.data);
    const now = Date.now();

    if (data && data.downloadUrl) {
      // Check if this is a duplicate event (same URL within debounce window)
      if (data.downloadUrl === lastProcessedUrl && now - lastProcessedTime < DEBOUNCE_MS) {
        return;
      }

      // Update tracking variables
      lastProcessedUrl = data.downloadUrl;
      lastProcessedTime = now;

      dispatch(downloadUrlReceived(data.downloadUrl));
    }
  } catch (error) {
    console.error('❌ SSE: Error parsing downloadUrl event:', error);
  }
};
